import { Form, Select } from "antd";
import { DefaultCriteriaEditorProps } from "../../../../types/bulkEmails/CriteriaOption";
import { useFetchImpoundTypes } from "../../hooks/useFetchImpoundTypes";

export const ImpoundTypesCriteriaSelect = ({ value, onChange, formKey }: DefaultCriteriaEditorProps) => {
  const handleChange = (selectedValues: string[]) => {
    onChange(selectedValues);
  };

  const { data, isLoading } = useFetchImpoundTypes();

  return (
    <Form.Item name={formKey} className="w-100 mb-0" preserve={false}>
      <Select
        className="w-100"
        mode="multiple"
        value={value}
        onChange={handleChange}
        disabled={isLoading}
        loading={isLoading}
      >
        {data.map((option) => (
          <Select.Option key={option.name} value={option.id}>
            {option.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
